import { lazy } from "react";
import Loader from "../components/Loader";
import { getDeviceModel } from "src/utils/getDeviceModel";
//import { elements } from "chart.js";

//ErrorPages
const DesktopRequired = lazy(() => import("src/pages/Errors/DesktopRequired/DesktopRequired"));
const Details = lazy(() => import("src/pages/MyIndicatorDashboards/Details"));
const Error403 = lazy(() => import("src/pages/Errors/Error403/Error403"));
const Error404 = lazy(() => import("src/pages/Errors/Error404/Error404"));

// dashboard routing
const MainLayout = lazy(() => import("../layout/MainLayout"));
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));
const ConfirmPassword = lazy(() => import("../pages/Login/ConfirmPassword"));
const Register = lazy(() => import("../pages/Register"));
const ConfirmRegister = lazy(() => import("../pages/Register/ConfirmEmail"));
const MyAccount = lazy(() => import("../pages/MyAccount"));
const MyAnalysisBoard = lazy(() => import("../pages/MyAnalysisBoard"));
const MyIndicatorDashboards = lazy(() => import("../pages/MyIndicatorDashboards"));
const DashboardEditor = lazy(() => import("../pages/MyIndicatorDashboards/DashboardEditor/DashboardEditor"));
const Partners = lazy(() => import("../pages/Partners"));
const PartnerSingle = lazy(() => import("../pages/Partners/PartnerSingleView"));
const DataAndIndicator = lazy(() => import("../pages/DataAndIndicator"));
const IndicatorMetadata = lazy(() => import("src/common/Indicators/IndicatorMetadata"));
const Editor = lazy(() => import("../pages/Editor"));
const Search = lazy(() => import("src/pages/Search/Search"));

// =====================|| POLICIES ROUTES ||=========+=========== //
const Policies = lazy(() => import("src/pages/Policies"));

// ======================|| THEMES ROUTES ||====================== //
const ThemeLayout = lazy(() => import("src/pages/Themes"));

// ====================|| BACKOFFICE ROUTES ||==================== //
const AddEntity = lazy(() => import("src/pages/BackOffice/ManageEntities/Form/AddEntity"));
const EditEntity = lazy(() => import("src/pages/BackOffice/ManageEntities/Form/EditEntity"));
const ManageEntities = lazy(() => import("src/pages/BackOffice/ManageEntities"));
const ManageIndicator = lazy(() => import("src/pages/BackOffice/ManageIndicator/index"));
const IndicatorForm = lazy(() => import("src/pages/BackOffice/ManageIndicator/Form/IndicatorForm"));
const ImportExcelFile = lazy(() => import("src/pages/BackOffice/ManageIndicator/ImportExcelFile"));
const ImportShapeFile = lazy(() => import("src/pages/BackOffice/ManageIndicator/ImportShapeFile"));
const ImportWFS = lazy(() => import("src/pages/BackOffice/ManageIndicator/ImportWFS"));
const ImportLogs = lazy(() => import("src/pages/BackOffice/ManageIndicator/ImportLogs"));
const ManageTheme = lazy(() => import("src/pages/BackOffice/ManageTheme"));
const ManagePolicies = lazy(() => import("src/pages/BackOffice/ManagePolicies"));
const ManagePolicyPageItems = lazy(() => import("src/pages/BackOffice/ManagePolicies/ManagePolicyPageItems"));
const ManageUsers = lazy(() => import("src/pages/BackOffice/ManageUsers"));
const AddUser = lazy(() => import("src/pages/BackOffice/ManageUsers/Form/AddUser"));
const EditUser = lazy(() => import("src/pages/BackOffice/ManageUsers/Form/EditUser"));
const SiteAnalytics = lazy(() => import("src/pages/BackOffice/SiteAnalytics/SiteAnalysis"));
const ManageHome = lazy(() => import("src/pages/BackOffice/ManageHome"));

// ======================|| FOOTER ROUTES ||====================== //
const AboutUs = lazy(() => import("../pages/Footer/AboutUs"));
const DataProtection = lazy(() => import("../pages/Footer/DataProtection"));
const LegalNotices = lazy(() => import("../pages/Footer/LegalNotices"));
const Contacts = lazy(() => import("../pages/Footer/Contacts"));
const MapSite = lazy(() => import("../pages/Footer/MapSite"));

const Redirect = lazy(() => import("src/common/Axios/Redirect"));

const isDesktopDevice = getDeviceModel() === "desktop";

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = [
    {
        path: "/",
        element: (
            <Loader>
                <MainLayout />
            </Loader>
        ),
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/search/:query",
                element: <Search />,
            },
            {
                path: "/login",
                element: <Login />,
            },
            {
                path: "/register",
                element: <Register />,
            },
            {
                path: "/my-account",
                element: <MyAccount />,
            },
            {
                path: "/my-analysis-board",
                element: <MyAnalysisBoard />,
            },
            {
                path: "/my_indicator_dashboards",
                children: [
                    {
                        path: "",
                        element: <MyIndicatorDashboards />,
                    },
                    {
                        path: "dashboard-editor",
                        element: <DashboardEditor />,
                    },
                    {
                        path: "details/:id",
                        element: <Details />,
                    },
                ],
            },
            {
                path: "/partners",
                element: <Partners />,
            },
            {
                path: "/partners/:pageName",
                element: <PartnerSingle />,
            },
            {
                path: "/about",
                element: <AboutUs />,
            },
            {
                path: "/data-protection",
                element: <DataProtection />,
            },
            {
                path: "/legal-notices",
                element: <LegalNotices />,
            },
            {
                path: "/contacts",
                element: <Contacts />,
            },
            {
                path: "/site-map",
                element: <MapSite />,
            },
            {
                path: "/indicators",
                children: [
                    { path: "", element: <DataAndIndicator /> },
                    { path: "metadata/:indicatorID", element: <IndicatorMetadata /> },
                ],
            },
            {
                path: "editor",
                element: <Editor />,
            },
            {
                path: "policies/:pageName",
                element: <Policies />,
            },
            {
                path: "themes/:pageName",
                element: <ThemeLayout />,
            },
            {
                path: "/backoffice",
                children: isDesktopDevice
                    ? [
                          {
                              path: "manage_entities",
                              children: [
                                  {
                                      path: "",
                                      element: <ManageEntities />,
                                  },
                                  {
                                      path: "add",
                                      element: <AddEntity />,
                                  },
                                  {
                                      path: "edit",
                                      element: <EditEntity />,
                                  },
                                  /* {
                                path: "edit_details",
                                element: ,
                            },
                            {
                                path: "edit_page",
                                element: ,
                            }, */
                              ],
                          },
                          {
                              path: "manage_indicators",
                              children: [
                                  {
                                      path: "",
                                      element: <ManageIndicator />,
                                  },
                                  {
                                      path: "add",
                                      element: <IndicatorForm />,
                                  },
                                  {
                                      path: "edit",
                                      element: <IndicatorForm />,
                                  },
                                  {
                                      path: "import_excel",
                                      element: <ImportExcelFile />,
                                  },
                                  {
                                      path: "import_shape",
                                      element: <ImportShapeFile />,
                                  },
                                  {
                                      path: "import_logs",
                                      element: <ImportLogs />,
                                  },
                                  {
                                      path: "import_wfs",
                                      element: <ImportWFS />,
                                  },
                              ],
                          },
                          {
                              path: "manage_themes",
                              children: [
                                  {
                                      path: "",
                                      element: <ManageTheme />,
                                  },
                              ],
                          },
                          {
                              path: "manage_policies",
                              children: [
                                  {
                                      path: "",
                                      element: <ManagePolicies />,
                                  },
                                  {
                                      path: ":pageName",
                                      element: <ManagePolicyPageItems />,
                                  },
                              ],
                          },
                          {
                              path: "manage_users",
                              children: [
                                  {
                                      path: "",
                                      element: <ManageUsers />,
                                  },
                                  {
                                      path: "add",
                                      element: <AddUser />,
                                  },
                                  {
                                      path: "edit",
                                      element: <EditUser />,
                                  },
                              ],
                          },
                          {
                              path: "site_analytics",
                              element: <SiteAnalytics />,
                          },
                          {
                              path: "manage_home",
                              element: <ManageHome />,
                          },
                      ]
                    : [
                          {
                              path: "*",
                              element: <DesktopRequired />,
                          },
                      ],
            },
            {
                path: "redirect",
                element: <Redirect />,
            },
            {
                path: "unauthorized",
                element: <Error403 />,
            },
            {
                path: "*",
                element: <Error404 />,
            },
        ],
    },
    {
        path: "/register/:isConfirmEmail",
        element: (
            <Loader>
                <ConfirmRegister />
            </Loader>
        ),
    },
    {
        path: "/recover/:isConfirmPass",
        element: (
            <Loader>
                <ConfirmPassword />
            </Loader>
        ),
    },
];

export default MainRoutes;
